import styled from 'styled-components'

import { AmexCard } from 'shared/icons/PaymentMethods/AmexCard'
import { DefaultCard } from 'shared/icons/PaymentMethods/DefaultCard'
import { MasterCard } from 'shared/icons/PaymentMethods/MasterCard'
import { VisaCard } from 'shared/icons/PaymentMethods/VisaCard'
import { t } from 'localization'

const TP = 'checkout.panels.PaymentMethod.NewCardPaymentOption'

export const NewCardPaymentOption = () => {
  return (
    <Container>
      <NewCard>
        <DefaultCard />
        <NewCardCopy>{t(`${TP}.addNewCard`, 'Add new card')}</NewCardCopy>
      </NewCard>
      <CardLogos>
        <VisaCard size="small" />
        <MasterCard size="small" />
        <AmexCard size="small" />
      </CardLogos>
    </Container>
  )
}

const CardLogos = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 116px;
`
const Container = styled.div`
  align-items: center;
  display: flex;
  height: 28px;
  justify-content: space-between;
  width: 100%;
`
const NewCard = styled.div`
  align-items: center;
  display: flex;
`
const NewCardCopy = styled.span`
  margin-left: 16px;
`
